import SubmitRequest from '../../SubmitRequest';
import ConsentCheckbox from '../ConsentCheckbox';
import FilesSection from '../FilesSection';
import PatientSection from '../PatientSection';
import SubmitToSection from '../SubmitToSection';
import { TemplateProps } from './TemplateProps';
import { useWorkflow } from "@/features/requests/api/getWorkflow";

const GenesisCareFormTemplate = ({ template }: TemplateProps) => {
  const { data: workflow } = useWorkflow({ id: template?.workflowId ?? '' });
  return (
    <>
      <SubmitToSection organizationId={workflow?.organizationId} />
      <PatientSection />
      <FilesSection />
      <ConsentCheckbox />
      <SubmitRequest template={template} />
    </>
  );
};

export { GenesisCareFormTemplate as default };
